
import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface NextStepsSectionProps {
  isPremium?: boolean;
}

const NextStepsSection: React.FC<NextStepsSectionProps> = ({ isPremium = false }) => {
  return (
    <div className="border rounded-lg p-4 mb-4 mt-6 bg-muted/30">
      <h3 className="font-medium mb-2">What happens next?</h3>
      <ul className="space-y-3">
        <li className="flex items-start gap-2">
          <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
          <span className="text-sm">Your responses have been recorded</span>
        </li>
        <li className="flex items-start gap-2">
          <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
          <span className="text-sm">You'll receive a confirmation email shortly</span>
        </li>
        {!isPremium && (
          <li className="flex items-start gap-2">
            <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
            <span className="text-sm">To access the full assessment or get detailed insights, please click the "Request Full Assessment Access" button below.</span>
          </li>
        )}
        {isPremium && (
          <li className="flex items-start gap-2">
            <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
            <span className="text-sm">You can view and download your results anytime from your dashboard.</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default NextStepsSection;
